import { formatDate, formatPrice, parseDate } from "@luce/core";

import { VoucherDiscountTypeEnum } from "../../__generated__/graphql";
import type { ClientVoucher } from "./types";

export function voucherDiscountLabel(
  voucher: Pick<ClientVoucher, "discountType" | "discountValue">,
) {
  return voucher.discountType === VoucherDiscountTypeEnum.Fixed
    ? formatPrice(voucher.discountValue)
    : `${voucher.discountValue}%`;
}

export function voucherExpiry(validUntil: string) {
  return `Expiring: ${formatDate(parseDate(validUntil), "dd MMM yyyy")}`;
}

export function isVoucherActive(voucher: Pick<ClientVoucher, "expiresInDays">) {
  return voucher.expiresInDays > 0;
}
